export const agentCommercePricingStyles: Record<string, React.CSSProperties> = {
  panel: {
    maxWidth: 720,
    padding: 16,
    border: "1px solid var(--color-border)",
    borderRadius: 8,
  },
  header: { marginBottom: 16 },
  title: { fontSize: 16, fontWeight: 600, marginBottom: 4 },
  description: {
    fontSize: 13,
    color: "var(--color-text-secondary)",
    lineHeight: 1.6,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
  },
  field: { display: "grid", gap: 6 },
  fieldFull: { display: "grid", gap: 6, gridColumn: "1 / -1" },
  label: {
    fontSize: 13,
    fontWeight: 500,
    color: "var(--color-text-secondary)",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    fontSize: 14,
    fontFamily: "var(--font-mono)",
  },
  textarea: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    resize: "vertical" as const,
    fontSize: 14,
    lineHeight: 1.5,
  },
  actions: { display: "flex", justifyContent: "flex-end", marginTop: 16 },
  primaryBtn: {
    padding: "8px 16px",
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-primary)",
    color: "#fff",
  },
  primaryBtnDisabled: { opacity: 0.5, cursor: "not-allowed" },
  error: {
    color: "var(--color-danger)",
    fontSize: 13,
    marginBottom: 12,
  },
  success: {
    color: "var(--color-success)",
    fontSize: 13,
    marginBottom: 12,
  },
};
